<template>
    <div class="gcmcn-card entity-event-card">

        <el-row :gutter="0">
            <el-col :span="24">
                <span class="event-name">{{ event.name }}</span><span> | {{ relatedUniverse.display_name }}</span>
            </el-col>
        </el-row>
        <div class="see-more-link" @click="showEvent">
            <i class="el-icon-view"></i>
            <span>SEE MORE</span>
        </div>
    </div>
</template>

<script>

export default {

    components: {

    },

    props: {
        event: {
            type: Object,
            required: true,
        },
        universes: {
            type: Array,
            required: true,
        },
    },

    data (){
        return {

        };
    },

    computed: {
        relatedUniverse (){
            return this.universes.find((uni) => uni.uid === this.event.universe_uid);
        },
    },

    mounted (){

    },

    methods: {
        showEvent () {
            this.$router.push({
                name: 'events',
                params: {
                    eventUid: this.event.uid,
                }
            });
        }
    },
};
</script>

<style lang="scss">
.entity-event-card {
    & + .entity-event-card{
        margin-top: 15px;
    }
    .event-name{
        font-weight: bold;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/page/Entities/event.vue